<template>
  <div id="app">
    <transition name="slide" mode="out-in">
      <router-view v-bind:key="key" />
    </transition>
    <Background />
    <Mobile />
  </div>
</template>
<script>
import Background from "@/components/background.vue";
import Mobile from "@/components/mobile.vue";
export default {
  components: {
    Background,
    Mobile
  },
  computed: {
    key() {
      return this.$route.meta.key !== undefined
        ? this.$route.meta.key
        : this.$route;
    }
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap");

$bgColor: #0a0c18;
$fontColor: #e5e7f9;

a {
  text-decoration: none;
  color: $fontColor;
  &:hover {
    text-decoration: none;
  }
  &:visited {
    color: $fontColor;
  }
}

@mixin fontSmallCaps($line-height) {
  font-size: 11px;
  font-weight: 300;
  line-height: $line-height;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  b {
    font-weight: 900;
  }
}

@mixin fontRegular($line-height, $letter-spacing) {
  font-size: 18px;
  font-weight: 300;
  line-height: $line-height;
  letter-spacing: $letter-spacing;
  b {
    font-weight: 900;
    letter-spacing: 0.5px;
  }
}
@mixin fontMassive() {
  font-size: 120px;
  font-weight: 900;
  line-height: 170px;
  letter-spacing: 2px;
  b {
    font-weight: 300;
  }
}

.fade-enter-active {
  transition: opacity 0.1s ease 0s;
}
.fade-leave-active {
  transition: opacity 0.1s ease 0s;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}

html,
body {
  font-family: "Roboto", sans-serif !important;
  color: $fontColor;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}

//QUICK RESET
h1,
h2,
h3,
h4,
p,
a,
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}

header {
  position: fixed;
  top: 40px;
  left: 0px;
  height: 40px;
  width: 100%;
  z-index: 10;

  #logo {
    position: absolute;
    top: 0px;
    left: 3%;
    @include fontSmallCaps(30px);
    span {
      display: inline-block;
    }
    &.logo-enter-active {
      transition: all 0.2s ease 0s;
    }
    &.logo-leave-active {
      transition: all 0.2s ease 0.1s;
    }
    &.logo-enter {
      transform: translateX(-100%);
      opacity: 0;
    }
    &.logo-enter-to {
      transform: translateX(0px);
      opacity: 1;
    }
    &.logo-leave {
      transform: translateX(0px);
      opacity: 1;
    }
    &.logo-leave-to {
      transform: translateX(-100%);
      opacity: 0;
    }
  }

  #menu {
    position: absolute;
    top: 0px;
    left: 40%;
    transition: left 0.3s ease 0s;
    &.scroll {
      left: 3%;
    }
    li {
      float: left;
      margin-right: 20px;
      &:last-child {
        margin-right: 0px;
      }
      a {
        float: left;
        @include fontSmallCaps(30px);
        transition: transform 0.1s ease 0s;
        &:hover {
          transform: scale(1.15);
        }
        &.router-link-exact-active {
          font-weight: 900;
        }
      }
    }
  }

  #leave {
    position: absolute;
    top: 0px;
    right: 3%;
    @include fontSmallCaps(30px);
    transition: transform 0.1s ease 0s;
    &::after {
      content: " ✖";
      float: right;
      padding-left: 10px;
      font-size: 24px !important;
    }
    &:hover {
      transform: scale(1.15);
    }
  }
}

.title {
  position: fixed;
  top: 50%;
  left: 0px;
  width: 100%;
  z-index: 1;
  transform: translateX(0);
  transition: transform 0.1s linear;
  h1 {
    @include fontMassive;
    margin-top: -85px;
    width: max-content;
    padding: 0 50%;
    opacity: 1;
    transform: translateX(0);
    transition: transform 0.1s linear;
    b {
      padding: 0 10px;
    }
  }
}

p {
  @include fontRegular(50px, 0px);
  // hyphens: auto;
  // text-align: justify;
  margin-bottom: 36px;
  text-shadow: 0px 0px 20px black;
  &:last-child {
    margin-bottom: 0px;
  }
  a {
    font-weight: 900;
    letter-spacing: 0.5px;
    &:hover {
      text-decoration: underline;
    }
  }
}

img,
video {
  width: 80%;
  margin: 25px 10%;
  position: relative;
  z-index: 5;
  box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.05);
}

.projList {
  li {
    position: relative;
    span {
      position: absolute;
      right: 100%;
      top: 0;
      text-align: right;
      padding-right: 10px;
      width: max-content;
      @include fontSmallCaps(45px);
    }
    a {
      @include fontRegular(45px, 0.5px);
      transition: transform 0.1s ease 0s;
      display: inline-block;
      &:hover {
        transform: scale(1.15);
        span {
          display: inline-block;
        }
      }
    }
  }
}

.next {
  position: fixed;
  bottom: 40px;
  right: 3%;
  z-index: 10;
  display: inline-block;
  @include fontSmallCaps(30px);
  transition: transform 0.1s ease 0s;
  &::after {
    content: "➡";
    float: right;
    padding-left: 10px;
    font-size: 16px !important;
  }
  &:hover {
    transform: scale(1.15);
  }
  &.next-enter-active {
    transition: all 0.2s ease;
  }
  &.next-leave-active {
    transition: all 0.2s ease;
  }
  &.next-enter {
    transform: translateX(-100%);
    opacity: 0;
  }
  &.next-enter-to {
    transform: translateX(0px);
    opacity: 1;
  }
  &.next-leave {
    transform: translateX(0px);
    opacity: 1;
  }
  &.next-leave-to {
    transform: translateX(33%);
    opacity: 0;
  }
}

.bgColor {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: $bgColor;
}

.views {
  float: left;
  width: 100%;
  min-height: 100%;
  left: 0px;
  transform: translateX(0);
  position: relative;
  z-index: 5;
  section {
    width: 40%;
    margin-left: 40%;
    position: relative;
    z-index: 5;
  }
  article {
    width: 76%;
    margin: 0 12%;
    padding: 100px 0;
    text-align: center;
  }
}

main {
  &.slide-enter-active {
    transition-duration: 0.5s;
    .bgColor {
      transition: transform 0.3s ease;
    }
    .views,
    .next,
    .projTitle,
    header {
      transition: transform 0.2s ease 0.3s, opacity 0.2s ease 0.3s;
    }
    .title {
      transition: left 0.2s ease 0.3s, opacity 0.2s ease 0.3s;
    }
  }
  &.slide-leave-active {
    transition-duration: 0.5s;
    .bgColor {
      transition: transform 0.3s ease 0.2s;
    }
    .views,
    .next,
    .projTitle,
    header {
      transition: transform 0.2s ease, opacity 0.2s ease;
    }
    .title {
      transition: left 0.2s ease, opacity 0.2s ease;
    }
  }
  &.slide-enter {
    .bgColor {
      transform: translateX(-100%);
    }
    .views,
    .next,
    .projTitle,
    header {
      transform: translateX(-50px);
      opacity: 0;
    }
    .title {
      left: -50px;
      opacity: 0;
    }
  }
  &.slide-enter-to {
    .bgColor {
      transform: translateX(0%);
    }
    .views,
    .next,
    .projTitle,
    header {
      transform: translateX(0px);
      opacity: 1;
    }
    .title {
      left: 0px;
      opacity: 1;
    }
  }
  &.slide-leave {
    .bgColor {
      transform: translateX(0%);
    }
    .views,
    .next,
    .projTitle,
    header {
      transform: translateX(0px);
      opacity: 1;
    }
    .title {
      left: 0px;
      opacity: 1;
    }
  }
  &.slide-leave-to {
    .bgColor {
      transform: translateX(100%);
    }
    .views,
    .next,
    .projTitle,
    header {
      transform: translateX(50px);
      opacity: 0;
    }
    .title {
      left: 50px;
      opacity: 0;
    }
  }
}
</style>
